import type { ColumnsType } from 'antd/es/table'

import type { FocusListOption } from 'features/catalog/types'

/** Up to 2 country names, then "+ N more". Drops the "Unknown" bucket from
 * the visible list (mirrors the removed CatalogListItem's formatter). */
function formatCountries(countries: string[]): string {
  const visible = countries.filter((c) => c !== 'Unknown')
  if (visible.length === 0) return '—'
  if (visible.length <= 2) return visible.join(', ')
  return `${visible.slice(0, 2).join(', ')} +${visible.length - 2} more`
}

/**
 * Countries column, shown for the Sources lens only. Extracted from
 * `use-catalog-table-columns.ts` (a plain, non-`use`-prefixed module, so it
 * stays out of `hook-max-lines`' scope) to keep that file under the 120-line
 * threshold. The row-actions ("View") column that used to live here moved to
 * the source detail page itself — see `CatalogSourceDetailPanel.tsx`.
 */
export function buildCatalogSourceColumns(params: {
  groupCountries: boolean
}): ColumnsType<FocusListOption> {
  const { groupCountries } = params
  return [
    {
      title: 'Countries',
      key: 'countries',
      width: 220,
      render: (_, row) =>
        groupCountries
          ? formatCountries(row.countries ?? [])
          : (row.country ?? '—'),
    },
  ]
}
